import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";
interface UseGetTraceabilityReportProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTraceabilityReport = async (communityId: string, year: string) =>
  await axiosAuth.get(`${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/traceability`);

const useGetTraceabilityReport = ({
  queryParams,
  communityId,
  year
}: UseGetTraceabilityReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["traceability-report", communityId, year],
    queryFn: () => getTraceabilityReport(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!queryParams?.enabled,
  });
};

export default useGetTraceabilityReport;
